import { CSSObjectWithLabel} from "react-select";

export const customStyles = {
  control: (
    base: CSSObjectWithLabel,
  ): CSSObjectWithLabel => ({
    ...base,
    borderRadius: '12px',
    border: '2px solid hsl(var(--primary))!important',
    height: 'auto',
    boxShadow: 'black',
    minHeight: '34px',
    minWidth: '50px',
    cursor: 'pointer',
  }),
  singleValue: (base: CSSObjectWithLabel) => ({
    ...base,
    color: 'black',
    fontSize: '12px',
    fontWeight: '600',
    
  }),
  valueContainer: (base: CSSObjectWithLabel) => ({
    ...base,
    padding: '0px',
    paddingLeft: '4px',
  }),
  dropdownIndicator:
    (base: CSSObjectWithLabel) => ({
      ...base,
      padding: '0 6px 0 4px',
      width: '24px',
      color: 'black',
    }),
  indicatorContainer: (base: CSSObjectWithLabel) => ({
    ...base,
    padding: '0!important',
    paddingLeft: '6px',
  }),
  indicatorSeparator: (base: CSSObjectWithLabel) => ({
    ...base,
    display: 'none',
  }),
  placeholder: (base: CSSObjectWithLabel) => ({
    ...base,
    color: 'black',
    fontSize: '14px',
    fontWeight: '600',
  }),
  menu: (base: CSSObjectWithLabel) => ({
    ...base,
    minWidth: '100px',
  }),
  option: (base: CSSObjectWithLabel, state: any) => ({
    ...base,
    color: state.isSelected ? 'white' : 'black',
    fontSize: '14px',
    fontWeight: '600',
    backgroundColor: state.isSelected ? 'hsl(var(--primary))' : 'transparent',
  }),
  input: (base: CSSObjectWithLabel) => ({
    ...base,
    margin: '0!important',
  }),
}